import type { ILineItem } from "../Summary";
import Base from "./Base";

export default class TinTie extends Base {
	public static optionSelector = 'input[name="tin-tie-option"]';
	private colourOptionContainer: HTMLDivElement;
	private readonly colourOptionSelect: HTMLSelectElement;

	/** @param onChange */
	constructor(onChange: () => void) {
		super(
			"tin-ties",
			() => {
				onChange();
			},
			TinTie.optionSelector,
			"exto-select-tin-ties",
		);
		this.colourOptionContainer = document.querySelector(
			".exto-tin-tie-colour-container",
		) as HTMLDivElement;
		this.colourOptionSelect = document.querySelector(
			".exto-tin-ties-colour-select",
		) as HTMLSelectElement;

		this.colourOptionSelect.addEventListener("change", () => {
			this.onChange();
		});
	}

	public errorMessage(): string {
		if (!this.isValid()) {
			return "Please select a tin-tie colour";
		}
		return "";
	}

	public getLineItems(): Array<ILineItem> {
		const output = [];
		if (this.isAdded) {
			const mainLineItem: ILineItem = {
				description: this.getActiveLabel(),
				key: "",
				label: "Tin-ties",
				value: this.getActiveOptionCost(),
			};

			output.push(mainLineItem);

			const { value } = this.colourOptionSelect;

			if (value) {
				const colourLineItem: ILineItem = {
					description: this.colourOptionSelect.value,
					key: "",
					label: "Tin-ties Colour",
					value: 0,
				};
				output.push(colourLineItem);
			}
		}
		return output;
	}

	public isValid() {
		const { value } = this.colourOptionSelect;
		return !this.isAdded || value !== "";
	}

	protected createDetailsForPHP() {
		const base = super.createDetailsForPHP();
		base.colour = this.colourOptionSelect.value.substring(0, 100);
		return base;
	}

	/**
	 * @param e
	 * @param newActiveValve
	 */
	protected setActiveOption(e: Event, newActiveValve: HTMLElement) {
		super.setActiveOption(e, newActiveValve);
		this.updateCustomDisplay();
	}

	protected updateCustomDisplay() {
		if (this.active.classList.contains("exto-tin-ties-colour")) {
			this.colourOptionContainer.classList.remove(this.hiddenClass);
		} else {
			this.colourOptionContainer.classList.add(this.hiddenClass);
		}
	}
}
